var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"livestream-edit-component"},[(_vm.livestreamID)?_c('editors',{attrs:{"resource":_vm.livestreamID}}):_vm._e(),_vm._v(" "),(_vm.livestreamLoaded)?_c('LivestreamForm',{attrs:{"livestream":_vm.livestream,"submitButtonLabel":'Update',"platforms":_vm.platforms},on:{"handle-form-submit":_vm.updateLivestream}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }